
interface Article {
  id: string;
  category: string;
  icon: string;
  title: string;
  summary: string;
  readTime: string;
  tags: string[];
}

interface KBArticleCardProps {
  article: Article;
  onClick: (id: string) => void;
  categoryLabel: string;
  categoryColor: string;
}

export default function KBArticleCard({ article, onClick, categoryLabel, categoryColor }: KBArticleCardProps) {
  return (
    <button
      onClick={() => onClick(article.id)}
      className="w-full text-left bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md hover:border-primary/30 transition-all duration-300 group cursor-pointer p-6 flex flex-col gap-4"
      aria-label={`Read article: ${article.title}`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className={`w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0 ${categoryColor}`}>
          <i className={`${article.icon} text-xl`} aria-hidden="true"></i>
        </div>
        <span className="text-xs font-semibold text-gray-400 bg-gray-50 px-3 py-1 rounded-full whitespace-nowrap">
          {article.readTime} read
        </span>
      </div>

      <div>
        <p className="text-xs font-semibold text-primary uppercase tracking-wide mb-2">{categoryLabel}</p>
        <h3 className="font-heading font-bold text-base text-secondary group-hover:text-primary transition-colors duration-200 leading-snug mb-2">
          {article.title}
        </h3>
        <p className="font-body text-sm text-gray-500 leading-relaxed line-clamp-2">{article.summary}</p>
      </div>

      <div className="flex flex-wrap gap-2 mt-auto">
        {article.tags.map((tag) => (
          <span
            key={tag}
            className="text-xs text-gray-400 bg-gray-50 px-2 py-0.5 rounded-full border border-gray-100"
          >
            #{tag}
          </span>
        ))}
      </div>

      <div className="flex items-center gap-1 text-primary text-sm font-semibold font-body">
        <span>Read article</span>
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-200" aria-hidden="true"></i>
        </div>
      </div>
    </button>
  );
}
